const RENEW_MARGIN_MS = 5 * 60_000
const AMZ_DATE = /^(\d{4})(\d{2})(\d{2})T(\d{2})(\d{2})(\d{2})Z$/

function expiresAt(url: URL): number | null {
  const date = url.searchParams.get('X-Amz-Date')?.match(AMZ_DATE)
  const seconds = Number(url.searchParams.get('X-Amz-Expires'))
  if (!date || !seconds) return null
  const [, year, month, day, hour, minute, second] = date.map(Number)
  return Date.UTC(year, month - 1, day, hour, minute, second) + seconds * 1000
}

export function stableSignedUrl(current: string | null | undefined, next: string, now = Date.now()): string {
  if (!current || !next) return next
  try {
    const kept = new URL(current)
    const incoming = new URL(next)
    if (kept.origin + kept.pathname !== incoming.origin + incoming.pathname) return next
    const expiry = expiresAt(kept)
    return expiry !== null && expiry - now > RENEW_MARGIN_MS ? current : next
  } catch {
    return next
  }
}
